// src/components/Login.js

import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, TextField, Button, CircularProgress, Typography } from '@mui/material';

import GlassCard from '../ui/glass/components/GlassCard';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();

  if (currentUser) { return <Navigate to="/" />; }

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email || !password) {
      setError('Lütfen tüm alanları doldurun.');
      setLoading(false);
      return;
    }

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      console.error("Giriş sırasında hata oluştu:", err);
      setError('Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
    }
    setLoading(false);
  };

  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundImage: 'url(/arkaplan.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}>
      <GlassCard
        component="form"
        onSubmit={handleLogin}
        sx={{
          p: { xs: 4, sm: 6 }, // Increased padding for clearer look
          width: '100%',
          maxWidth: '400px',
          mx: 2,
          // GlassCard internal Box handling overrides direct Flex on Card, 
          // so we rely on inner Stack for layout
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>

          {/* Logo Section */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <Box
              component="img"
              src="/reslife-logo.png"
              alt="ResLife Logo"
              sx={{
                width: '100%',
                maxWidth: '200px',
                height: 'auto',
                objectFit: 'contain'
              }}
            />
          </Box>

          {/* Inputs Section */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
            <TextField
              label="E-posta Adresi"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
              autoFocus
              variant="outlined"
              sx={{
                '& .MuiInputBase-input': { color: '#1a1a1a', fontWeight: 500 },
                '& .MuiInputLabel-root': { color: '#64748b' },
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  backdropFilter: 'blur(4px)',
                  borderRadius: '12px', // More rounded
                  '& fieldset': { borderColor: 'rgba(0,0,0,0.1)' },
                  '&:hover fieldset': { borderColor: '#0891b2' },
                  '&.Mui-focused fieldset': { borderColor: '#0891b2', borderWidth: 2 },
                }
              }}
            />

            <TextField
              label="Şifre"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              fullWidth
              variant="outlined"
              sx={{
                '& .MuiInputBase-input': { color: '#1a1a1a', fontWeight: 500 },
                '& .MuiInputLabel-root': { color: '#64748b' },
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'rgba(255, 255, 255, 0.8)',
                  backdropFilter: 'blur(4px)',
                  borderRadius: '12px',
                  '& fieldset': { borderColor: 'rgba(0,0,0,0.1)' },
                  '&:hover fieldset': { borderColor: '#0891b2' },
                  '&.Mui-focused fieldset': { borderColor: '#0891b2', borderWidth: 2 },
                }
              }}
            />
          </Box>

          {error && (
            <Typography
              color="error"
              align="center"
              variant="body2"
              sx={{
                mt: 1,
                py: 1,
                px: 2,
                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                borderRadius: 2,
                fontWeight: 500
              }}
            >
              {error}
            </Typography>
          )}

          <Button
            type="submit"
            variant="contained"
            size="large"
            disabled={loading}
            fullWidth
            sx={{
              mt: 2,
              py: 1.5,
              fontSize: '1rem',
              borderRadius: '12px',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: '0 4px 14px 0 rgba(8, 145, 178, 0.4)',
              '&:hover': {
                backgroundColor: '#0e7490',
                boxShadow: '0 6px 20px 0 rgba(8, 145, 178, 0.6)',
              }
            }}
          >
            {loading ? <CircularProgress size={26} color="inherit" /> : 'Giriş Yap'}
          </Button>

        </Box>
      </GlassCard>
    </Box>
  );
};

export default Login;
